import { notify } from './toast';

export const getNFDomain = async (walletAddress: string): Promise<string | null> => {
  try {
    const url = `https://api.nf.domains/nfd/lookup?address=${walletAddress}&limit=20&view=tiny&allowUnverified=true`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Accept": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch NFD data');
    }

    const data = await response.json();
    
    if (data && data[walletAddress]) {
      if (data[walletAddress].name) {
        return data[walletAddress].name;
      }
    }
    return null;
  } catch (error) {
    console.log(`Wallet ${walletAddress.substring(0, 8)}... has no NFD names!`);
    return null;
  }
};